import { createRouter, createWebHashHistory } from 'vue-router'

import Home from '@/view/home/index.vue'
import Detail from '@/view/detail/Index.vue'
import Try from '@/view/try/Index.vue'
import Activities from '@/view/activities/Index.vue'
import OldHome from '@/view/home/old_index.vue'
import Canvas from '@/view/canvas/Index.vue'
import Explore from '@/view/explore/Index.vue'
import Philosophy from '@/view/philosophy/Index.vue'
import Stats from '@/view/stats/Index.vue'
import Tech from '@/view/tech/Index.vue'
import Partners from '@/view/partners/Index.vue'
import Article1 from '@/view/article/1.vue'
import Cookie from '@/view/Cookie.vue'
import Privacy from '@/view/Privacy.vue'
import Service from '@/view/Service.vue'
import AboutMe from '@/view/about/Index.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/old_home',
    name: 'OldHome',
    component: OldHome
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail
  },
  {
    path: '/lab',
    name: 'Try',
    component: Try
  },
  {
    path: '/activities',
    name: 'Activities',
    component: Activities
  },
  {
    path: '/canvas',
    name: 'Canvas',
    component: Canvas
  },
  {
    path: '/explore',
    name: 'Explore',
    component: Explore
  },
  {
    path: '/philosophy',
    name: 'Philosophy',
    component: Philosophy
  },
  {
    path: '/stats',
    name: 'Stats',
    component: Stats
  },
  {
    path: '/tech',
    name: 'Tech',
    component: Tech
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners
  },
  {
    path: '/article1',
    name: 'Article1',
    component: Article1
  },
  {
    path: '/cookie',
    name: 'Cookie',
    component: Cookie
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/service',
    name: 'Service',
    component: Service
  },
  {
    path: '/about',
    name: 'AboutMe',
    component: AboutMe
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,

  // 🔥 🔥 🔥 【关键：页面切换自动回到顶部】
  scrollBehavior() {
    return {
      top: 0,
      behavior: 'instant' // 瞬间回到顶部，无动画
    }
  }
})

export default router